function MainCtrl($rootScope, $scope, $state, $stateParams, $timeout, toastr, DashboardService, AppContextService, UserService, PlanService, PermissionService) {
  'ngInject';

  // ViewModel
  const vm = this;
  vm.appContext = AppContextService.context;

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    vm.isDebugger = true;
  }

  

}


export default {
  name: 'MainCtrl',
  fn: MainCtrl
};
